import { Navigate, RouteObject } from 'react-router-dom';
import UserFeaturesGuard from '~/guards/UserFeaturesGuard';
import { RouteConfig } from '~/routes/routeConfig';
import { FeatureFlag } from '~/types/company';
import lazyImport from '~/utils/lazyImport';
import { transactionsRulesRoutes } from '~/views/transactions-rules/routing/transactions-rules-routes';

const TransactionsPage = lazyImport(() => import('~/views/banks/Transactions'));
const TransactionsRulesPage = lazyImport(() => import('~/views/transactions-rules/TransactionsRulesRoute'));
const PaymentPage = lazyImport(() => import('~/views/payments/PaymentPage'));

export const transactionsRoutes: RouteObject[] = [
  {
    path: 'movements/*',
    element: <TransactionsPage />,
  },
  {
    path: 'rules/*',
    element: <TransactionsRulesPage />,
    children: transactionsRulesRoutes,
  },
  {
    path: 'payments/*',
    element: (
      <UserFeaturesGuard requiredFeatures={[FeatureFlag.Payments]}>
        <PaymentPage />
      </UserFeaturesGuard>
    ),
  },
  {
    path: '*',
    element: <Navigate to={RouteConfig.Transactions.buildLinkWithChildPath('movements')} replace />,
  },
];
